import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './FoldersList.css';
import { FoldersListItemAllContainer, FoldersListItemContainer } from '../../containers/FoldersList';
import { IFavoritesFolder } from '../../types/favoriteEntity';

interface IProps {
  folders: IFavoritesFolder[];
  create: React.ReactNode;
  showLoadMoreButton: boolean;
  onLoadMoreButtonClick: () => void;
}

export function FoldersList({ folders, create, showLoadMoreButton, onLoadMoreButtonClick }: IProps) {
  return (
    <div>
      <FoldersListItemAllContainer />
      <div className={styles['title']}>Мои подборки</div>
      {create}
      {folders.map(folder => (
        <FoldersListItemContainer key={folder.id} folder={folder} />
      ))}
      {showLoadMoreButton && (
        <div className={styles['load-more-button']} onClick={onLoadMoreButtonClick}>
          <UIText2 as="div" color="primary_100" fontWeight="bold">
            Показать еще
          </UIText2>
        </div>
      )}
    </div>
  );
}
